const CloverB = () => {
  const clover =
    process.env.PUBLIC_URL +
    `./assets/wheel_deluxe/suitsBordered/clover.png`;
  return <img src={clover}/>;
};

const HeartB = () => {
  const heart =
    process.env.PUBLIC_URL + `./assets/wheel_deluxe/suitsBordered/heart.png`;
  return <img src={heart}/>;
};

const JokerB = () => {
  const joker =
    process.env.PUBLIC_URL +
    `./assets/wheel_deluxe/suits/joker.png`;
  return <img src={joker}/>;
};

const PikesB = () => {
  const pikes =
    process.env.PUBLIC_URL + `./assets/wheel_deluxe/suitsBordered/pikes.png`;
  return <img src={pikes}/>;
};

const TilesB = () => {
  const tiles =
    process.env.PUBLIC_URL + `./assets/wheel_deluxe/suitsBordered/tiles.png`;
  return <img src={tiles}/>;
};

export {CloverB, HeartB, JokerB, PikesB, TilesB};
